import { render, staticRenderFns } from "./QueryCatalog.vue?vue&type=template&id=2623117c&"
import script from "./QueryCatalog.vue?vue&type=script&lang=js&"
export * from "./QueryCatalog.vue?vue&type=script&lang=js&"
import style0 from "./QueryCatalog.vue?vue&type=style&index=0&id=2623117c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports